import { Text } from '@adc/parallax-component-library';
import { FormContainer, Input } from 'Components/utility';
import { format, parseISO } from 'date-fns';
import i18n from 'Utilities/i18n';

import { ContentContainer, type CreateAccountFormDefinition } from '../helpers';

type RegisterMinorAccountInfoProps = {
  formikForm: CreateAccountFormDefinition;
};

function RegisterMinorAccountInfo({ formikForm }: RegisterMinorAccountInfoProps) {
  const { errors, values, touched, handleChange, handleBlur } = formikForm;

  return (
    <ContentContainer>
      <Text>
        {i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.primaryText')}
      </Text>
      <FormContainer hasHiddenUserInput>
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.label'
          )}
          placeholder={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.placeholder'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.label'
          )}
          testID="guardianFirstName"
          inputMode="text"
          errorMessage={errors.guardianFirstName}
          isInvalid={Boolean(errors.guardianFirstName && touched.guardianFirstName)}
          value={values.guardianFirstName}
          onChangeText={handleChange('guardianFirstName')}
          onBlur={handleBlur('guardianFirstName')}
        />
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.label'
          )}
          placeholder={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.placeholder'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.label'
          )}
          testID="guardianLastName"
          inputMode="text"
          errorMessage={errors.guardianLastName}
          isInvalid={Boolean(errors.guardianLastName && touched.guardianLastName)}
          value={values.guardianLastName}
          onChangeText={handleChange('guardianLastName')}
          onBlur={handleBlur('guardianLastName')}
        />

        <Text
          nativeID="CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.secondaryText"
          fontWeight="$bodyBase.medium"
          fontSize="$bodyBase.medium"
          color="$text.60"
          paddingTop="$5"
          textTransform="uppercase"
        >
          {i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.secondaryText'
          )}
        </Text>
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'
          )}
          testID="firstName"
          inputMode="text"
          value={values.firstName}
          disabled
        />
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'
          )}
          testID="lastName"
          inputMode="text"
          value={values.lastName}
          disabled
        />
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.label'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.label'
          )}
          testID="dateOfBirth"
          inputMode="text"
          value={values.dateOfBirth ? format(parseISO(values.dateOfBirth), 'MM/dd/yyyy') : ''}
          disabled
        />
      </FormContainer>
    </ContentContainer>
  );
}

export { RegisterMinorAccountInfo };
